module.exports = __webpack_public_path__ + "static/media/37.d6f4be56.svg";